import { render, staticRenderFns } from "./GoodsFilter.vue?vue&type=template&id=8a7ed352&scoped=true"
import script from "./GoodsFilter.vue?vue&type=script&lang=js"
export * from "./GoodsFilter.vue?vue&type=script&lang=js"
import style0 from "./GoodsFilter.vue?vue&type=style&index=0&id=8a7ed352&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7ed352",
  null
  
)

export default component.exports